import Vue from 'vue'
import App from './App.vue'
import router from './router/router'

import './lib/index.js'
import './plugins/index.js'

import './lib/rem.js';
import less from 'less'
// import loading from './components/loading.vue';
import globalImg from './global/index'
import navBar from './components/navBar.vue';
import navLeftBar from './components/navLeftBar.vue';
import month from './components/month.vue';
import global from './lib/global.vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

Vue.use(ElementUI)

Vue.use(less)
Vue.component('navBar', navBar)
Vue.component('navLeftBar', navLeftBar)
Vue.component('month', month)
    // Vue.component('loading', loading)
Vue.config.productionTip = false
Vue.prototype.$global = globalImg
Vue.prototype.$globalUrl = global

new Vue({
    router,
    watch: {
        $route() {
            document.title = `${this.$route.meta.title}`
            document.querySelector('#app').setAttribute('style', `background: ${this.$route.meta.backgroundColor}`)
        }
    },
    render: h => h(App)
}).$mount('#app')